module.exports = __webpack_public_path__ + "static/media/sms-code.b4ac046d.svg";